import React from "react";
import Box from "@mui/material/Box";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const CheckTextbox = ({ text }) => {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        backgroundColor: "#FFFFFF",
        borderRadius: "16px",
        px: "14px",
        py: "10px",
        m: "6px",
        fontSize: { xs: 13, sm: 14 },
        color: "#445",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      }}
    >
      <CheckCircleIcon color="primary" sx={{ fontSize: 20 }} />
      {text}
    </Box>
  );
};

export default CheckTextbox;
